import buildTextInputDefinition, {
    TextInputDefinition
} from "../../../../../../../utils/forms/models/grid-fields/text-input-definition";
import buildNumberInputDefinition, {
    NumberInputDefinition
} from "../../../../../../../utils/forms/models/grid-fields/number-input-definition";
import { FormDefinition } from "../../../../../../../utils/forms/builders/build-form-grid-fields";
import { GROUP_TYPE } from "../../../../../reducers/editingConfiguration.reducer";
import buildTextAreaDefinition, {
    TextAreaDefinition
} from "../../../../../../../utils/forms/models/grid-fields/text-area-definition";
import buildBulletsSelectorDefinition, {
    BulletsSelectorDefinition
} from "../../../../../../../utils/forms/models/grid-fields/bullets-selector-definition";
import buildSwitchDefinition, {
    SwitchDefinition
} from "../../../../../../../utils/forms/models/grid-fields/switch-definition";
import buildSelectMenuDefinition, {
    SelectMenuDefinition
} from "../../../../../../../utils/forms/models/grid-fields/select-menu-definition";
import buildBetJackpotArrayDefinition, { BetJackpotArrayDefinition } from "../../../../../../../utils/forms/models/grid-fields/bet-jackpot-array-definition";
import * as Yup from "yup";
import React from "react";
import buildInputSearchDefinition, {InputSearchDefinition} from "../../../../../../../utils/forms/models/grid-fields/input-search-definition";

export const CARD_TITLE = "Progressives";

export const FORM_TYPE_NAMES = {
    easylink: "EasyLink",
    multipots: "Multipots",
    jumbolink: "Jumbo Link",
    luckytokenslink: "LuckyToken",
    levels: "Levels",
    sap: "SAP",
    fractionated: "Fractionated",
    reelstrike: "Reel Strike"
};

export const LEVELS_NAMES = {
    0: "Mega",
    1: "Grand",
    2: "Major",
    3: "Minor",
    4: "Mini"
};

export const PROGRESSIVE_CHILDREN_TYPES = [
    {
        value: "proportional",
        label: "Proportional"
    },
    {
        value: "normal",
        label: "Normal"
    },
    {
        value: "fractionated",
        label: "Fractionated"
    },
    {
        value: "reelstrike",
        label: "reelstrike"
    },
];

export enum SCHEMA_NAMES {
    ID = "id",
    COIN = "coin",
    GLOBAL_JACKPOT_SOUND = "play_jackpot_sound",
    TERMINAL_GROUPS = "terminal_groups",
    GAME_GROUPS = "game_groups",
    GROUPS = "groups",
    INITIAL_VALUE = "initial_value",
    MAX_VALUE = "max_value",
    CONTRIBUTION = "contribution",
    MAX_BET = "max_bet",
    MIN_BET = "min_bet",
    RESERVE_MAX_VALUE = "reserve_max_value",
    RESERVE_CONTRIBUTION = "reserve_contribution",
    GLOBAL_INCREMENT_SOUND = "global_increment_sound",
    INCREMENT_SOUND_VALUE = "increment_sound_value",
    INDIVIDUAL_POT = "individual_pot",
    ACTIVE = "active",
    INDEX = "level_index",
    PRIZE_INDEX = "prize_index",
    TITLE = "title",
    PROPORTIONAL_TYPE = "proportion_type",
    PRESET = "preset",
    PRIZES = "prizes",
    TYPE = "type",
    MIN_GAME_MODE = 'min_game_mode',
    MAX_PROPORTIONAL_TOTAL_BET = 'max_proportional_total_bet',
    DISPLAY_ID_PANEL = 'display_id_panel',
    FRACTIONATED_JACKPOT_LIST = 'fractionated_jackpot_list',
    RTP = 'rtp',
    GAME_SPECIFIC_SETTINGS= 'game_specific_settings'
}

const PROGRESSIVE_ID: TextInputDefinition = buildTextInputDefinition({
    name: "id",
    id: "proportional_id",
    placeholder: "Insert ID",
    label: "ID",
    schemaName: SCHEMA_NAMES.ID,
    fieldOverrides: { disabled: true }
});

const DISPLAY_ID_PANEL: SwitchDefinition = buildSwitchDefinition({
    name: "display_id_panel",
    id: "display_id_panel",
    label: "Display ID in Panel",
    schemaName: SCHEMA_NAMES.DISPLAY_ID_PANEL
});

const PROGRESSIVE_TYPE: SelectMenuDefinition = buildSelectMenuDefinition({
    name: "type",
    id: "proportional_type",
    label: "Type",
    noValueLabel: "",
    items: [
        {
            value: "multipots",
            label: "multipots"
        },
        {
            value: "jumbolink",
            label: "jumbolink"
        },
        {
            value: "luckytokenslink",
            label: "luckytokenslink"
        },
        {
            value: "reelstrike",
            label: "reelstrike"
        },
        {
            value: "easylink",
            label: "easylink"
        },
        {
            value: "levels",
            label: "levels"
        },
        {
            value: "sap",
            label: "sap"
        }
    ],
    schemaName: SCHEMA_NAMES.TYPE
});

const PROGRESSIVE_PRESET: (
    items: { label: string | number; value: string | number }[]
) => InputSearchDefinition = items =>
    buildInputSearchDefinition({
        name: "preset",
        id: "proportional_preset",
        label: "Preset",
        schemaName: SCHEMA_NAMES.PRESET,
        items: items,
        selectedFilters:'',
        searchAction: ''
    });

const FRACTIONATED_JACKPOT_LIST: (
    items: { label: string | number; value: string | number }[]
) => BetJackpotArrayDefinition = (items) =>
    buildBetJackpotArrayDefinition({
        name: "fractionated_jackpot_list",
        id: "fractionated_jackpot_list",
        label: "Fractionated Jackpot List",
        disabled: true,
        items: items,
        schemaName: SCHEMA_NAMES.FRACTIONATED_JACKPOT_LIST,
        fieldOverrides: {
            formSpacing: false,
            columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        }
    });

const COIN: (
    items: { label: string | number; value: string | number }[],
    exclusive: boolean
) => BulletsSelectorDefinition = (items, exclusive) =>
    buildBulletsSelectorDefinition({
        name: "coin",
        id: "proportional_coin",
        label: "Coin",
        items: items,
        completeList: items,
        exclusive: exclusive,
        schemaName: SCHEMA_NAMES.COIN,
        fieldOverrides: {
            formSpacing: false,
            multipleSelection: true,
            columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        }
    });

const PROPORTIONAL_TYPE: (
    items: { label: string | number; value: string | number }[]
) => SelectMenuDefinition = items =>
    buildSelectMenuDefinition({
        name: "proportion_type",
        id: "proportion_type",
        label: "Proportional Type",
        items: items,
        noValueLabel: "Choose a Type..",
        schemaName: SCHEMA_NAMES.PROPORTIONAL_TYPE
    });

const GLOBAL_JACKPOT_SOUND: SwitchDefinition = buildSwitchDefinition({
    name: "play_jackpot_sound",
    id: "progressivePlayJackpotSound",
    label: "Play Jackpot Sound",
    schemaName: SCHEMA_NAMES.GLOBAL_JACKPOT_SOUND,
    fieldOverrides: {
        columnClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }
});

const TERMINAL_GROUPS: (
    items: { label: string | number; value: string | number }[],
    completeList: { label: string | number; value: string | number }[]
) => BulletsSelectorDefinition = (items, completeList) =>
    buildBulletsSelectorDefinition({
        name: "terminal_groups",
        id: "terminal_groups",
        label: "Groups",
        schemaName: SCHEMA_NAMES.TERMINAL_GROUPS,
        completeList,
        orderByLabel: true,
        items,
        fieldOverrides: {
            formSpacing: false,
            columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        }
    });

const GAME_GROUPS: (
    items: { label: string | number; value: string | number }[],
    completeList: { label: string | number; value: string | number }[]
) => BulletsSelectorDefinition = (items, completeList) => {
    return buildBulletsSelectorDefinition({
        name: "game_groups",
        id: "game_groups",
        label: "Groups",
        schemaName: SCHEMA_NAMES.GAME_GROUPS,
        completeList,
        orderByLabel: true,
        items,
        fieldOverrides: {
            formSpacing: false,
            columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
        }
    });
};

const INITIAL_VALUE: NumberInputDefinition = buildNumberInputDefinition({
    name: "initial_value",
    id: "init_value",
    placeholder: "Insert Initial Value",
    label: "Initial Value",
    schemaName: SCHEMA_NAMES.INITIAL_VALUE
});

const MAX_VALUE: NumberInputDefinition = buildNumberInputDefinition({
    name: "max_value",
    id: "max_value",
    placeholder: "Insert Max Value",
    label: "Maximum Value",
    schemaName: SCHEMA_NAMES.MAX_VALUE
});

const CONTRIBUTION: NumberInputDefinition = buildNumberInputDefinition({
    name: "contribution",
    id: "contrib",
    placeholder: "Insert Contribution",
    label: "Contribution",
    schemaName: SCHEMA_NAMES.CONTRIBUTION
});

/*const MAX_BET: NumberInputDefinition = buildNumberInputDefinition({
    name: "max_bet",
    id: "max_bet",
    placeholder: "Insert Maximum Bet",
    label: "Maximum Bet",
    schemaName: SCHEMA_NAMES.MAX_BET
});*/

const MAX_BET: (label?: string, placeholder?: string) => NumberInputDefinition =
    (label, placeholder) => {
        let newLabel = label !== undefined ? label : "Maximum Bet";
        let newPlaceholder =
            placeholder !== undefined ? placeholder : "Insert Maximum Bet";
        return buildNumberInputDefinition({
            name: "max_bet",
            id: "max_bet",
            placeholder: newPlaceholder,
            label: newLabel,
            schemaName: SCHEMA_NAMES.MAX_BET
        });
    };

const MIN_BET: NumberInputDefinition = buildNumberInputDefinition({
    name: "min_bet",
    id: "min_bet",
    placeholder: "Insert Minimum Bet",
    label: "Minimum Bet",
    schemaName: SCHEMA_NAMES.MIN_BET
});

const RESERVE_MAX_VALUE: NumberInputDefinition = buildNumberInputDefinition({
    name: "reserve_max_value",
    id: "res_max_value",
    placeholder: "Insert Reserve Max Value",
    label: "Reserve Max Value",
    schemaName: SCHEMA_NAMES.RESERVE_MAX_VALUE
});

const RESERVE_CONTRIBUTION: NumberInputDefinition = buildNumberInputDefinition({
    name: "reserve_contribution",
    id: "res_contrib",
    placeholder: "Insert Reserve Contribution",
    label: "Reserve Contribution",
    schemaName: SCHEMA_NAMES.RESERVE_CONTRIBUTION
});

const GLOBAL_INCREMENT_SOUND: SwitchDefinition = buildSwitchDefinition({
    name: "global_increment_sound",
    id: "proportional_global_inc_sound",
    label: "Globally Increment Sound",
    schemaName: SCHEMA_NAMES.GLOBAL_INCREMENT_SOUND
});

const INCREMENT_SOUND_VALUE: NumberInputDefinition = buildNumberInputDefinition(
    {
        name: "increment_sound_value",
        id: "inc_sound_value",
        placeholder: "Insert Value to Play Increment Sound",
        label: "Value to Play Increment Sounds",
        schemaName: SCHEMA_NAMES.INCREMENT_SOUND_VALUE
    }
);

const INDIVIDUAL_POT: SwitchDefinition = buildSwitchDefinition({
    name: "individual_pot",
    id: "individual_pot",
    label: "Individual Pot",
    schemaName: SCHEMA_NAMES.INDIVIDUAL_POT,
    fieldOverrides: {
        columnClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12"
    }
});

const GROUPS_PLACEHOLDER: TextAreaDefinition = buildTextAreaDefinition({
    name: "groups_placeholder",
    id: "noGroupsSelectedPlaceholder",
    text: `To assign a terminal group or group of games to a progressive, please define your preferences at jackpot groups section.`,
    placeholder: `To assign a terminal group or group of games to a progressive, please define your preferences at jackpot groups section.`,
    label: "Groups",
    disabled: true,
    schemaName: "groups_placeholder",
    fieldOverrides: {
        formSpacing: false,
        columnClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 empty-groups"
    }
});

const LEVELS_WARNING: TextAreaDefinition = buildTextAreaDefinition({
    name: "levels_warning",
    id: "levelsWarningOrder",
    text: `Levels are ordered from Lowest (4) to Highest (0).
    To include a Level it must be set active.`,
    label: "Levels",
    disabled: true,
    fieldOverrides: {
        columnClass:
            "col-lg-12 col-md-12 col-sm-12 col-xs-12 warning-levels hidden"
    }
});

const PROGRESSIVE_INDEX: TextInputDefinition = buildTextInputDefinition({
    name: "level_index",
    id: "proportional_level_index",
    label: "Level Index",
    placeholder: "",
    schemaName: SCHEMA_NAMES.INDEX,
    fieldOverrides: {
        formSpacing: false,
        columnClass:
            "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 opacity-free disabled hidden"
    }
});

const PROGRESSIVE_PRIZE_INDEX: (type) => SelectMenuDefinition = (type) =>
    buildSelectMenuDefinition(
        {
            name: "prize_index",
            id: "proportional_prize_index",
            label: "Prize Index",
            items: [
                {
                    value: 0,
                    label: "0"
                },
                {
                    value: 1,
                    label: "1"
                },
                {
                    value: 2,
                    label: "2"
                },
                {
                    value: 3,
                    label: "3"
                },
                {
                    value: 4,
                    label: "5"
                }
            ],
            noValueLabel: type,
            schemaName: SCHEMA_NAMES.PRIZE_INDEX,
            fieldOverrides: {
                formSpacing: false,
                columnClass:
                    "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 opacity-free disabled hidden"
            }
        }
    )

const PROGRESSIVE_TITLE: TextInputDefinition = buildTextInputDefinition({
    name: "level_title",
    id: "proportional_level_title",
    label: "Level Title",
    placeholder: "",
    schemaName: SCHEMA_NAMES.TITLE,
    fieldOverrides: {
        formSpacing: false,
        columnClass:
            "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 opacity-free disabled hidden"
    }
});

const PROGRESSIVE_ACTIVE: SwitchDefinition = buildSwitchDefinition({
    name: "active",
    id: "proportional_active",
    label: "Level Active",
    schemaName: SCHEMA_NAMES.ACTIVE,
    fieldOverrides: {
        formSpacing: false,
        columnClass:
            "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 opacity-free"
    }
});

const MIN_GAME_MODE: NumberInputDefinition = buildNumberInputDefinition({
    name: "min_game_mode",
    id: "min_game_mode",
    placeholder: "Insert Min. Game Mode",
    label: "Min. Game Mode",
    schemaName: SCHEMA_NAMES.MIN_GAME_MODE
});

const MAX_PROPORTIONAL_TOTAL_BET: NumberInputDefinition = buildNumberInputDefinition({
    name: "max_proportional_total_bet",
    id: "max_proportional_total_bet",
    placeholder: "Insert Max. Proportional Total Bet",
    label: "Max. Proportional Total Bet",
    schemaName: SCHEMA_NAMES.MAX_PROPORTIONAL_TOTAL_BET
});

const RTP: TextInputDefinition = buildTextInputDefinition({
    name: "rtp",
    id: "rtp",
    placeholder: "Insert RTP",
    label: "RTP",
    schemaName: SCHEMA_NAMES.RTP
});

const GAME_SPECIFIC_SETTINGS: TextAreaDefinition = buildTextAreaDefinition({
    name: "game_specific_settings",
    id: "GameSpecificSettings",
    text: ``,
    placeholder: ``,
    label: "",
    disabled: true,
    schemaName: SCHEMA_NAMES.GAME_SPECIFIC_SETTINGS,
    fieldOverrides: {
        formSpacing: false,
        columnClass: "col-lg-12 col-md-12 col-sm-12 col-xs-12 empty-groups visibility-hidden"
    }
});

export function progressiveFormDefinition(
    groupType: GROUP_TYPE,
    coins: { label: string | number; value: string | number }[],
    fullGroupList?: { label: string | number; value: string | number }[],
    selectedGroupList?: { label: string | number; value: string | number }[],
    proportionalTypes?: { label: string | number; value: string | number }[],
    presets?: { label: string | number; value: string | number }[],
    overwriteNames?: any,
    exclusives?: string[],
    hasIndividualPot?: boolean,
    formType?: any
): FormDefinition {
    return {
        [SCHEMA_NAMES.ID]: {
            definition: {
                ...PROGRESSIVE_ID,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 0
        },
        [SCHEMA_NAMES.DISPLAY_ID_PANEL]: {
            definition: {
                ...DISPLAY_ID_PANEL,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 0
        },
        [SCHEMA_NAMES.TYPE]: {
            definition: {
                ...PROGRESSIVE_TYPE,
                fieldOverrides: {
                    formSpacing: false,
                    disabled: true,
                    columnClass:
                        "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 hidden"
                }
            },
            order: 0
        },
        [SCHEMA_NAMES.PRESET]: {
            definition: {
                ...PROGRESSIVE_PRESET(presets),
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6"
                }
            },
            order: 0
        },
        [SCHEMA_NAMES.INDEX]: {
            definition: PROGRESSIVE_INDEX,
            order: 0
        },
        [SCHEMA_NAMES.PRIZE_INDEX]: {
            definition: PROGRESSIVE_PRIZE_INDEX(formType),
            order: 0
        },
        [SCHEMA_NAMES.ACTIVE]: {
            definition: PROGRESSIVE_ACTIVE,
            order: 0
        },
        [SCHEMA_NAMES.TITLE]: {
            definition: PROGRESSIVE_TITLE,
            order: 0
        },
        [SCHEMA_NAMES.PRIZES]: {
            definition: LEVELS_WARNING,
            order: 0
        },
        [SCHEMA_NAMES.INITIAL_VALUE]: {
            definition: {
                ...INITIAL_VALUE,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4"
                },
                disabled: formType && formType == "fractionated"
            },
            order: formType && formType == "fractionated" ? 5 : 1
        },
        [SCHEMA_NAMES.MAX_VALUE]: {
            definition: {
                ...MAX_VALUE,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4"
                },
                disabled: formType && formType == "fractionated"
            },
            order: formType && formType == "fractionated" ? 6 : 2
        },
        [SCHEMA_NAMES.GLOBAL_JACKPOT_SOUND]: {
            definition: {
                ...GLOBAL_JACKPOT_SOUND,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4"
                }
            },
            order: formType && formType == "fractionated" ? 9 : 3
        },
        [SCHEMA_NAMES.COIN]: {
            definition: COIN(
                coins,
                exclusives && exclusives.includes(SCHEMA_NAMES.COIN)
            ),
            order: 4
        },
        ...(formType != "fractionated" && {
            [SCHEMA_NAMES.FRACTIONATED_JACKPOT_LIST]: {
                definition: FRACTIONATED_JACKPOT_LIST(coins),
                order: 10
            }
        }),
        ...(groupType === GROUP_TYPE.TERMINAL && {
            [SCHEMA_NAMES.GROUPS]: {
                definition: TERMINAL_GROUPS(selectedGroupList, fullGroupList),
                order: formType && formType == "fractionated" ? 3 : 5
            }
        }),
        ...(groupType === GROUP_TYPE.GAME && {
            [SCHEMA_NAMES.GROUPS]: {
                definition: GAME_GROUPS(selectedGroupList, fullGroupList),
                order: formType && formType == "fractionated" ? 3 : 5
            }
        }),
        ...(![GROUP_TYPE.TERMINAL, GROUP_TYPE.GAME].includes(groupType) && {
            [SCHEMA_NAMES.GROUPS]: {
                definition: GROUPS_PLACEHOLDER,
                order: formType && formType == "fractionated" ? 3 : 5
            }
        }),
        [SCHEMA_NAMES.CONTRIBUTION]: {
            definition: {
                ...CONTRIBUTION,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4 percentage"
                },
                disabled: formType && formType == "fractionated"
            },
            order: formType && formType == "fractionated" ? 7 : 6
        },
        [SCHEMA_NAMES.PROPORTIONAL_TYPE]: {
            definition: {
                ...PROPORTIONAL_TYPE(proportionalTypes),
                fieldOverrides: {
                    formSpacing: false,
                    columnClass:
                        "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3 button-selector"
                }
            },
            order: 7
        },
        [SCHEMA_NAMES.RESERVE_CONTRIBUTION]: {
            definition: {
                ...RESERVE_CONTRIBUTION,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 7
        },
        [SCHEMA_NAMES.MAX_BET]: {
            definition: {
                ...MAX_BET(
                    overwriteNames && overwriteNames.hasOwnProperty("max_bet")
                        ? overwriteNames.max_bet
                        : undefined,
                    overwriteNames &&
                        overwriteNames.hasOwnProperty("max_bet_placeholder")
                        ? overwriteNames.max_bet_placeholder
                        : undefined
                ),
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4"
                }
            },
            order: 8
        },
        [SCHEMA_NAMES.MIN_BET]: {
            definition: {
                ...MIN_BET,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4"
                }
            },
            order: 8
        },
        [SCHEMA_NAMES.RESERVE_MAX_VALUE]: {
            definition: {
                ...RESERVE_MAX_VALUE,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 9
        },
        [SCHEMA_NAMES.INCREMENT_SOUND_VALUE]: {
            definition: {
                ...INCREMENT_SOUND_VALUE,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"
                }
            },
            order: formType && formType == "fractionated" ? 8 : 10
        },
        [SCHEMA_NAMES.GLOBAL_INCREMENT_SOUND]: {
            definition: {
                ...GLOBAL_INCREMENT_SOUND,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3"
                }
            },
            order: 11
        },
        [SCHEMA_NAMES.INDIVIDUAL_POT]: {
            definition: {
                ...INDIVIDUAL_POT,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: hasIndividualPot == true ? "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3" : 'hidden'
                }
            },
            order: 11
        },
        [SCHEMA_NAMES.MIN_GAME_MODE]: {
            definition: {
                ...MIN_GAME_MODE,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: (formType == 'easylink' || formType == 'luckytokenslink') ? "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3" : 'hidden'
                }
            },
            order: 12
        },
        [SCHEMA_NAMES.MAX_PROPORTIONAL_TOTAL_BET]: {
            definition: {
                ...MAX_PROPORTIONAL_TOTAL_BET,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: (formType == 'easylink' || formType == 'luckytokenslink' || formType == 'multipots' || formType == 'jumbolink' || formType == 'luckytokenslink')  ? "col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-3" : 'hidden'
                }
            },
            order: 13
        },
        [SCHEMA_NAMES.RTP]: {
            definition: {
                ...RTP,
                fieldOverrides: {
                    formSpacing: false,
                    columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                }
            },
            order: 14
        },
        ...((formType == 'easylink' || formType == 'luckytokenslink') && {
            [SCHEMA_NAMES.GAME_SPECIFIC_SETTINGS]: {
                definition: {
                    ...GAME_SPECIFIC_SETTINGS,
                    fieldOverrides: {
                        formSpacing: false,
                        columnClass: "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 visibility-hidden"
                    }
                },
                order: 15
            }
        }),
    };
}

export const PROGRESSIVES_FIELD_NAMES = {
    level_title: "Level",
    [SCHEMA_NAMES.GLOBAL_JACKPOT_SOUND]: "Play Jackpot Sound",
    [SCHEMA_NAMES.MAX_VALUE]: "Maximum Value",
    [SCHEMA_NAMES.CONTRIBUTION]: "Contribution",
    [SCHEMA_NAMES.MAX_BET]: "Maximum Bet",
    [SCHEMA_NAMES.MIN_BET]: "Minimum Bet",
    [SCHEMA_NAMES.RESERVE_MAX_VALUE]: "Reserve Max Value",
    [SCHEMA_NAMES.RESERVE_CONTRIBUTION]: "Reserve Contribution",
    [SCHEMA_NAMES.GLOBAL_INCREMENT_SOUND]: "Global Increment Sound",
    [SCHEMA_NAMES.INCREMENT_SOUND_VALUE]: "Increment Sound Value",
    [SCHEMA_NAMES.ACTIVE]: "Active",
    [SCHEMA_NAMES.INDEX]: "Level Index",
    [SCHEMA_NAMES.TITLE]: "Title",
    [SCHEMA_NAMES.PROPORTIONAL_TYPE]: "Type",
    [SCHEMA_NAMES.PRESET]: "Preset",
    [SCHEMA_NAMES.PRIZES]: "Prizes",
    children: "Progressive Groups",
    [SCHEMA_NAMES.TYPE]: "Type",
    [SCHEMA_NAMES.COIN]: "Coin",
    [SCHEMA_NAMES.TERMINAL_GROUPS]: "Terminal Groups",
    [SCHEMA_NAMES.GAME_GROUPS]: "Game Groups",
    [SCHEMA_NAMES.INITIAL_VALUE]: "Initial Value",
    [SCHEMA_NAMES.INDIVIDUAL_POT]: "Individual Pot",
    [SCHEMA_NAMES.MIN_GAME_MODE]: "Min. Game Mode",
    [SCHEMA_NAMES.MAX_PROPORTIONAL_TOTAL_BET]: "Max. Proportional Total Bet",
};
